/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const customTextTeachingBubbleMessages = defineMessages({
    addClassButtonTitle: { id: 'customText.customTextTeachingBubbleMessages.addClassButtonTitle', defaultMessage: 'Add a class' },
    examineModelTitle: { id: 'customText.customTextTeachingBubbleMessages.examineModelTitle', defaultMessage: 'Examine your model' },
    viewingDropDownTitle: { id: 'customText.customTextTeachingBubbleMessages.viewingDropDownTitle', defaultMessage: 'Filter Files' },
    saveTagsButtonTitle: { id: 'customText.customTextTeachingBubbleMessages.saveTagsButtonTitle', defaultMessage: 'Save your labels' },
    createNewProjectTitle: {
        id: 'customText.customTextTeachingBubbleMessages.createNewProjectTitle',
        defaultMessage: 'Create a new project'
    },
    createNewProjectBody: {
        id: 'customText.customTextTeachingBubbleMessages.createNewProjectBody',
        defaultMessage:
            'Click create a new project to start a new custom text "{ projectsType }" project. You’ll need a Azure Storage account with your documents in an Azure Blob store'
    },
    filesViewerSearchButtonTitle: {
        id: 'customText.customTextTeachingBubbleMessages.filesViewerSearchButtonTitle',
        defaultMessage: 'Search for documents'
    },
    filesViewerSearchButtonBody: {
        id: 'customText.customTextTeachingBubbleMessages.filesViewerSearchButtonBody',
        defaultMessage: 'You can search for documents by title or keyword. Then you can label the results of this search.'
    },
    viewingDropDownBody: {
        id: 'customText.customTextTeachingBubbleMessages.viewingDropDownBody',
        defaultMessage:
            "You're currently looking at all documents in your dataset. You can change the filter from here to view your labeled documents or the unlabeled documents"
    },
    addEntityButtonTitle: {
        id: 'customText.customTextTeachingBubbleMessages.addEntityButtonTitle',
        defaultMessage: 'Add and label entities'
    },
    addEntityButtonBody: {
        id: 'customText.customTextTeachingBubbleMessages.addEntityButtonBody',
        defaultMessage:
            'Select Add entity to begin adding the entities you want to label. You can use the highlighter icon next to the entity to label the text or select the text in the document to label.'
    },
    autoLabelButtonTitle: {
        id: 'customText.customTextTeachingBubbleMessages.autoLabelButtonTitle',
        defaultMessage: 'Auto-label your files with GPT'
    },
    autoLabelButtonBody: {
        id: 'customText.customTextTeachingBubbleMessages.autoLabelButtonBody',
        defaultMessage: `You can speed up the data labeling process by using Azure OpenAI's GPT technology to label your documents.After the labels have been suggested you can review the labels.`
    },
    saveTagsButtonBody: {
        id: 'customText.customTextTeachingBubbleMessages.saveTagsButtonBody',
        defaultMessage: 'Save the labels you’ve applied at any time. They will also automatically save when you move to the next document.'
    },
    moveBetweenDocumentsTitle: {
        id: 'customText.customTextTeachingBubbleMessages.moveBetweenDocumentsTitle',
        defaultMessage: 'Move between documents'
    },
    moveBetweenDocumentsBody: {
        id: 'customText.customTextTeachingBubbleMessages.moveBetweenDocumentsBody',
        defaultMessage: 'Navigate between your documents by selecting Back and Next. Labels will save when you move to a new document'
    },
    dataTaggingPaletteTitle: {
        id: 'customText.customTextTeachingBubbleMessages.dataTaggingPaletteTitle',
        defaultMessage: 'Right nav pane'
    },
    dataTaggingPaletteBody: {
        id: 'customText.customTextTeachingBubbleMessages.dataTaggingPaletteBody',
        defaultMessage: 'Use this pane to create "{ paletteType }", label documents and check when you are ready for training.'
    },
    addClassButtonBody: {
        id: 'customText.customTextTeachingBubbleMessages.addClassButtonBody',
        defaultMessage: 'Add a class to begin labeling your documents'
    },
    trainingLimitsUITitle: {
        id: 'customText.customTextTeachingBubbleMessages.trainingLimitsUITitle',
        defaultMessage: 'Know when to train'
    },
    trainingLimitsUIBody: {
        id: 'customText.customTextTeachingBubbleMessages.trainingLimitsUIBody',
        defaultMessage: 'Find out when your project is ready for training and how much left you need to label'
    },
    examineModelBody: {
        id: 'customText.customTextTeachingBubbleMessages.examineModelBody',
        defaultMessage: 'Once your model is trained, you can view details such as performance metrics and information about the test set'
    },
    reviewAutotagsTitle: {
        id: 'customText.customTextTeachingBubbleMessages.reviewAutotagsTitle',
        defaultMessage: 'Review autotags'
    },
    reviewAutotagsBody: {
        id: 'customText.customTextTeachingBubbleMessages.reviewAutotagsBody',
        defaultMessage: 'Review the autotags after the job is finished'
    }
});
